import { Button, Label, TextInput, Table } from "flowbite-react";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import { IoMdClose } from "react-icons/io";
import CustomSelect from "../hooks/CustomSelect";
import CustomSelectwithText from "../hooks/CustomSelectwithText";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSidebar } from "../context/SidebarOpenContext";
import Breadcrumb from "../hooks/Breadcrumb";
import { RiInboxArchiveFill } from "react-icons/ri";
import { Modal } from "flowbite-react";

function Addorder() {
    const navigate = useNavigate();
    const [selectedStyle, setselectedStyle] = useState('');
    const [selectedBuyer, setselectedBuyer] = useState('');
    const [selectedBoxing, setselectedBoxing] = useState('');
    const [Customer, setCustomer] = useState({});
    const [Colour, setColour] = useState({});
    const [Style, setStyle] = useState({});
    const [Marker, setMarker] = useState({});
    const [Input, setInput] = useState({ orderdate: "", cutorderno: "", pono: "", delivery_date: "" });
    //  total_piece: 0,
    const [openModal, setOpenModal] = useState(false);

    const today = new Date().toISOString().split('T')[0];
    const url = localStorage.getItem("url");
    const { isSidebarOpen } = useSidebar();
    const [errors, setErrors] = useState({});

    useEffect(() => {
        fetchcustomer();
        fetchColour();
        fetchstyle();
        fetchmarker();
    }, []);

    const fetchcustomer = async () => {
        try {
            const response = await axios.get("master/buyers");
            const CustomerData = response.data;
            setCustomer(CustomerData);
        } catch (error) {
            console.error("Error fetching customer data:", error);
        }
    };

    const fetchColour = async () => {
        try {
            const response = await axios.get("master/colours");
            const ColourData = response.data;
            setColour(ColourData);
        } catch (error) {
            console.error("Error fetching Colour data:", error);
        }
    };

    const fetchGetcutordernumber = async (selectedBuyerid, orderdate) => {
        try {
            const response = await axios.get(`order/orders/getcutordernumber/${selectedBuyerid}`, {
                params: {
                    orderdate: orderdate
                }
            });
            const Data = response.data;
            setInput(prevInput => ({
                ...prevInput,
                cutorderno: Data.order_code
            }));
        } catch (error) {
            console.error("Error fetching Colour data:", error);
        }
    };


    const fetchstyle = async () => {
        try {
            const response = await axios.get("master/styles");
            const StyleData = response.data;
            setStyle(StyleData);
        } catch (error) {
            console.error("Error fetching Style data:", error);
        }
    };

    const fetchmarker = async () => {
        try {
            const response = await axios.get("master/size_variants");
            const markerData = response.data;
            setMarker(markerData);
        } catch (error) {
            console.error("Error fetching Marker data:", error);
        }
    };

    const Style_options = Style.length > 0 ? Style.map(style => ({
        value: style.style_id,
        label: style.style_name,
    })) : [];

    const Boxing_options = [
        { label: "Single Boxing", value: "Single" },
        { label: "Group Boxing", value: "Group" },
    ];

    const selectedstylevalue = Style.length > 0 && Style.find(item => item.style_id == selectedStyle);

    const sizeVariantType = selectedstylevalue ? selectedstylevalue.size_variant_type : null;

    const sizevariantOptions = Marker.length > 0
        ? Marker.filter(marker => marker.type == sizeVariantType)
            .map(marker => ({
                value: marker.size_id,
                label: marker.size
            }))
        : [];

    const Buyer_options = Customer.length > 0 ? Customer.map(customer => ({
        value: customer.customer_id,
        label: customer.customer_name,
    })) : [];

    const Colour_options = Colour.length > 0
        ? Colour.map(colour => ({
            value: colour.colour_id,
            label: colour.colour_name,
            imgSrc: colour.colour_image ? `${url}${colour.colour_image}` : null,
        }))
        : [];


    const onChangeValue = (e) => {
        const { name, value } = e.target;
        setInput((prev) => ({ ...prev, [name]: value }));
    }

    const AddOrder = async (event) => {
        event.preventDefault();
        if (
            !Input.orderdate.trim() ||
            !selectedBuyer ||
            !selectedBoxing ||
            !selectedStyle ||
            !Input.pono.trim() ||
            overallTotal <= 0 ||
            !Object.keys(combinedTotals).length ||
            !Array.isArray(rows) || rows.length === 0 ||
            rows.some(row =>
                !row.colour ||
                !Object.keys(row.selectedMarker).length ||
                !Object.keys(row.size_variant_price).length ||
                Object.keys(row.selectedMarker).some(sizeId => !row.size_variant_price[sizeId])
            ) ||
            !Object.keys(totals).length ||
            !Input.cutorderno.trim() ||
            !Input.delivery_date.trim()
        ) {
            Swal.fire({
                icon: "error",
                text: "Please fill all required fields",
                timer: 2000,
                showConfirmButton: false,
            });
            return;
        }
        try {
            axios
                .post(`order/orders`, {
                    order_date: Input.orderdate,
                    buyer_id: selectedBuyer,
                    boxing_type: selectedBoxing,
                    style_id: selectedStyle,
                    po_num: Input.pono,
                    total_piece: overallTotal,
                    total_size_variant_quantity: combinedTotals,
                    colour_with_size_variant_quantity: rows,
                    colour_wise_total_piece: totals,
                    cut_order_no: Input.cutorderno,
                    delivery_date: Input.delivery_date,
                    eopercentage: Input.eopercentage
                })
                .then((res) => {
                    if (res.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Order  Created",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        navigate("/order");
                    } else if (res.data.success === 2) {
                        Swal.fire({
                            icon: "error",
                            text: "Cut Order Number already exists...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }

    };


    const breadcrumbItems = [
        {
            href: "/order",
            label: "Order",
            icon: (
                <RiInboxArchiveFill className="flex-shrink-0 w-5 h-5  " />

            ),
        },
        {
            label: "Add Order",
        },

    ];

    useEffect(() => {
        if (selectedBuyer && Input.orderdate) {
            fetchGetcutordernumber(selectedBuyer, Input.orderdate);
        }
    }, [selectedBuyer, Input.orderdate]);

    const [rows, setRows] = useState([
        { colour: "", selectedMarker: {}, size_variant_price: {} },

    ]);
    const [totals, setTotals] = useState({});
    const [overallTotal, setOverallTotal] = useState(0);
    const [combinedTotals, setCombinedTotals] = useState({});

    const addRow = () => {
        const newRow = { colour: "", selectedMarker: {}, size_variant_price: {} };
        setRows([...rows, newRow]);
    };


    const deleteRow = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);

        const updatedTotals = { ...totals };
        delete updatedTotals[index];
        setTotals(updatedTotals);

        recalculateTotals(updatedRows);
    };

    const handleColourChange = (index, value) => {
        addRow();
        setRows((prevRows) => {
            const isDuplicate = prevRows.some(
                (row, i) => i !== index && row.colour === value
            );
            if (isDuplicate) {
                return prevRows;
            }
            return prevRows.map((row, i) =>
                i === index ? { ...row, colour: value } : row
            );
        });
    };

    const handlePriceChange = (rowIndex, sizeId, value) => {
        if (value === "" || /^[0-9]*$/.test(value)) {
            setRows((prevRows) =>
                prevRows.map((row, i) => {
                    if (i === rowIndex) {
                        const updatedPrice = { ...row.size_variant_price, [sizeId]: value };
                        return { ...row, size_variant_price: updatedPrice };
                    }
                    return row;
                })
            );
        }
    };



    const handleMarkerChange = (index, selectedMarker) => {
        setRows((prevRows) =>
            prevRows.map((row, i) =>
                i === index ? { ...row, selectedMarker } : row
            )
        );

        const total = Object.values(selectedMarker).reduce(
            (sum, val) => sum + parseInt(val || 0, 10),
            0
        );

        setTotals((prevTotals) => ({ ...prevTotals, [index]: total }));

        recalculateTotals(rows.map((row, i) =>
            i === index ? { ...row, selectedMarker } : row
        ));
    };

    const recalculateTotals = (rows) => {
        const combined = {};
        let overall = 0;

        rows.forEach((row) => {
            Object.entries(row.selectedMarker).forEach(([key, value]) => {
                const numericValue = parseInt(value || 0, 10);
                if (!combined[key]) {
                    combined[key] = 0;
                }
                combined[key] += numericValue;
                overall += numericValue;
            });
        });

        setCombinedTotals(combined);
        setOverallTotal(overall);
    };

    const removeEmptyRows = () => {
        const cleanedRows = rows.filter(row => {
            const hasColour = row.colour;
            const hasMarker = row.selectedMarker && Object.keys(row.selectedMarker).length > 0;
            const hasPrice = row.size_variant_price && Object.values(row.size_variant_price).some(val => val !== "");
            return hasColour || hasMarker || hasPrice;
        });
        setRows(cleanedRows);
    };

    return (
        <div className={` ${isSidebarOpen ? "p-4 sm:ml-64 bg-content-bg min-h-screen " : "p-4  bg-content-bg min-h-screen"}  `} >
            <div className="p-4 rounded-lg dark:border-gray-700  mt-14  h-full">
                <div className="p-4 rounded-lg shadow bg-white ">
                    <div className="space-y-6">
                        <Breadcrumb items={breadcrumbItems} />
                        <h3 className="text-xl font-medium text-sidebar-color dark:text-white">
                            Add Order
                        </h3>
                        <form method="post">
                            <div className="flex gap-4">
                                <div className="w-1/2">
                                    <div className="mb-2 block  ">
                                        <Label htmlFor="password" value="Order Date" />
                                    </div>
                                    <TextInput
                                        name="orderdate"
                                        type="date"
                                        required
                                        autoComplete="off"
                                        max={today}
                                        onChange={(e) => {
                                            onChangeValue(e);
                                        }}

                                    />
                                </div>
                                <div className="w-1/2">
                                    <div className="mb-2 block">
                                        <Label htmlFor="buyer" value="Buyer Name" />
                                    </div>
                                    <CustomSelect
                                        value={selectedBuyer}
                                        onChange={(selected) => {
                                            setselectedBuyer(selected);
                                        }}
                                        options={Buyer_options}
                                        placeholder="Select an option"
                                        id="buyer-select"
                                        name="buyerSelect"
                                    />
                                </div>
                            </div>
                            <div className="flex gap-4 mt-4">

                                <div className="w-1/2">
                                    <div className="mb-2 block">
                                        <Label htmlFor="buyer" value="Style" />
                                    </div>
                                    <CustomSelect
                                        value={selectedStyle}
                                        onChange={setselectedStyle}
                                        options={Style_options}
                                        placeholder="Select an style"
                                        id="style-select"
                                        name="styleSelect"
                                    />
                                </div>
                                <div className="w-1/2">
                                    <div className="mb-2 block  ">
                                        <Label htmlFor="jobno" value="PO Number" />
                                    </div>
                                    <TextInput
                                        name="pono"
                                        type="text"
                                        required
                                        autoComplete="off"
                                        onChange={onChangeValue}
                                    />
                                </div>
                            </div>
                            <div className="flex gap-4 mt-4">

                                <div className="w-1/2">
                                    <div className="mb-2 block">
                                        <Label htmlFor="cutorderno" value="Order Number" />
                                    </div>
                                    <TextInput
                                        name="cutorderno"
                                        type="text"
                                        required
                                        autoComplete="off"
                                        value={Input.cutorderno}
                                        readonly
                                    />
                                </div>
                                <div className="w-1/2">
                                    <div className="mb-2 block">
                                        <Label htmlFor="delivery_date" value="Delivery Date" />
                                    </div>
                                    <TextInput
                                        name="delivery_date"
                                        type="date"
                                        autoComplete="off"
                                        min={Input.orderdate || ""}  // Prevent choosing before order date
                                        value={Input.delivery_date}
                                        onChange={(e) => onChangeValue(e)}
                                    />
                                </div>
                            </div>

                            <div className="flex gap-4 mt-4">

                                <div className="w-1/2">
                                    <div className="mb-2 block">
                                        <Label htmlFor="Excess order percentage" value="Excess order percentage" />
                                    </div>
                                    <TextInput
                                        name="eopercentage"
                                        type="text"
                                        required
                                        autoComplete="off"
                                        onChange={onChangeValue}
                                        onInput={(e) => {
                                            if (e.target.value > 100) e.target.value = 100;
                                            if (e.target.value < 0) e.target.value = 0;
                                        }}
                                        min={0}
                                        max={100}
                                    />
                                </div>
                                <div className="w-1/2">
                                    <div className="mb-2 block">
                                        <Label htmlFor="buyer" value="Boxing Type" />
                                    </div>
                                    <CustomSelect
                                        value={selectedBoxing}
                                        onChange={(selected) => {
                                            setselectedBoxing(selected);
                                        }}
                                        options={Boxing_options}
                                        placeholder="Select an option"
                                        id="buyer-select"
                                        name="buyerSelect"
                                    />
                                </div>
                            </div>

                            <div className=" flex items-center pt-4">
                                <h3 className="text-lg font-medium text-sidebar-color dark:text-white mr-2">
                                    Selected Quantity Based on Colour
                                </h3>
                                <Button className="bg-sidebar-color text-white" size="xs" onClick={() => {
                                    // addRow()
                                    if (rows.length === 0) {
                                        addRow(); // Add a row only if the table is empty
                                    }
                                    setOpenModal(true)
                                }}> Add</Button>
                            </div>
                            <div className="overflow-x-auto "  >
                                <Modal show={openModal} onClose={() => {
                                    setOpenModal(false)
                                    removeEmptyRows();
                                }} size="7xl">
                                    <Modal.Header>Enter Price for Selected Sizes</Modal.Header>
                                    <Modal.Body>
                                        <div className="flex justify-end mb-2"> {/* New Container */}
                                            <Button className="bg-sidebar-color text-white" size="xs" onClick={addRow}>
                                                + Add Row
                                            </Button>
                                        </div>
                                        <div className="overflow-auto max-h-[70vh]">
                                            <Table hoverable className="border mt-4">
                                                <Table.Head className="border">
                                                    <Table.HeadCell className="border min-w-[200px]">Colour</Table.HeadCell>
                                                    <Table.HeadCell className="border min-w-[350px]">Selected Quantity</Table.HeadCell>
                                                    <Table.HeadCell className="border">Total</Table.HeadCell>
                                                    <Table.HeadCell className="border">Price</Table.HeadCell>
                                                    <Table.HeadCell className="border">Delete</Table.HeadCell>
                                                </Table.Head>

                                                <Table.Body className="divide-y border">
                                                    {rows.map((row, index) => (
                                                        <Table.Row key={index} className="border">
                                                            <Table.Cell className="border">
                                                                <CustomSelect
                                                                    value={row.colour}
                                                                    onChange={(selectedOptions) => handleColourChange(index, selectedOptions)}
                                                                    options={Colour_options}
                                                                    placeholder="Select a colour"
                                                                    id={`colour-${index}`}
                                                                    name={`colour-${index}`}
                                                                    menuPortalTarget={document.body}
                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                    includeImage={true}
                                                                />
                                                            </Table.Cell>

                                                            <Table.Cell className="border">
                                                                <CustomSelectwithText
                                                                    value={row.selectedMarker}
                                                                    onChange={(selectedOptions) => handleMarkerChange(index, selectedOptions)}
                                                                    options={sizevariantOptions}
                                                                    id={`marker-${index}`}
                                                                    name={`marker-${index}`}
                                                                    menuPortalTarget={document.body}
                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                    onWheel={(e) => e.target.blur()}
                                                                />
                                                            </Table.Cell>

                                                            <Table.Cell className="border text-center">
                                                                {totals[index] || 0}
                                                            </Table.Cell>

                                                            <Table.Cell className="border text-center align-top">
                                                                <div className="grid grid-cols-3 gap-1 ">
                                                                    {Object.entries(row.selectedMarker).map(([sizeId, quantity], i) => (
                                                                        <div
                                                                            key={sizeId}
                                                                            className="flex flex-col items-start w-[150px] mb-1"
                                                                        >
                                                                            <span className="text-sm font-small">
                                                                                {sizevariantOptions.find(opt => opt.value === parseInt(sizeId))?.label || sizeId}
                                                                            </span>
                                                                            <TextInput
                                                                                value={row.size_variant_price[sizeId] || ""}
                                                                                onChange={(e) => handlePriceChange(index, sizeId, e.target.value)}
                                                                                placeholder="Price"
                                                                                type="text"
                                                                                className="w-1/2"
                                                                            />
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </Table.Cell>



                                                            <Table.Cell className="border text-center">
                                                                <IoMdClose
                                                                    size={24}
                                                                    style={{
                                                                        color: rows.length === 1 ? "grey" : "red",
                                                                        cursor: rows.length === 1 ? "not-allowed" : "pointer",
                                                                    }}
                                                                    onClick={rows.length === 1 ? null : () => deleteRow(index)}
                                                                />
                                                            </Table.Cell>
                                                        </Table.Row>
                                                    ))}
                                                </Table.Body>
                                            </Table>
                                        </div>
                                    </Modal.Body>
                                    {/* <Modal.Footer className="z-0 h-10">
                                        <Button color="gray" onClick={() => setOpenModal(false)}>Ok</Button>
                                    </Modal.Footer> */}
                                </Modal>
                                {Object.keys(combinedTotals).length > 0 ? (
                                    <div className="overflow-x-auto mt-4">
                                        <Table className="border">
                                            <Table.Head className="border">
                                                <Table.HeadCell className="border">Size</Table.HeadCell>
                                                {Object.keys(combinedTotals).map((key) => (
                                                    <Table.HeadCell key={key} className="border">
                                                        {sizevariantOptions.find(option => option.value === parseInt(key))?.label || key}
                                                    </Table.HeadCell>
                                                ))}
                                                <Table.HeadCell className="border">Total</Table.HeadCell>
                                            </Table.Head>
                                            <Table.Body className="divide-y">
                                                <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                                                    <Table.Cell className="border whitespace-nowrap font-medium text-gray-900 dark:text-white">
                                                        Quantity
                                                    </Table.Cell>
                                                    {Object.keys(combinedTotals).map((key) => (
                                                        <Table.Cell key={key} className="border">
                                                            {combinedTotals[key] || 0}
                                                        </Table.Cell>
                                                    ))}
                                                    <Table.Cell className="border">
                                                        {overallTotal}
                                                    </Table.Cell>
                                                </Table.Row>
                                            </Table.Body>
                                        </Table>
                                    </div>
                                ) : (
                                    <div className="overflow-x-auto mt-4  pt-[100px]  ">
                                    </div>
                                )}
                            </div>

                            <div className="flex justify-center gap-4 pt-4">
                                <Button
                                    className="bg-icon-color text-sidebar-color drop-shadow-md font-bold"
                                    type="button"
                                    onClick={AddOrder}
                                >
                                    {"Submit"}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Addorder;
